import { type JSX } from "react";

import { Combobox as BaseCombobox } from "@base-ui/react/combobox";
import { useControlContext } from "@frontend/contexts";

import { ComboboxContext, makeComboboxContext } from "./Combobox.context";
import type { ComboboxProps } from "./Combobox.types";

export function Combobox<Value, Multiple extends boolean | undefined = false>({
  size,
  ...props
}: ComboboxProps<Value, Multiple>): JSX.Element {
  const inherited = useControlContext();
  const resolvedSize = size ?? inherited.size;

  return (
    <ComboboxContext.Provider
      value={makeComboboxContext({ size: resolvedSize })}
    >
      <BaseCombobox.Root data-slot="combobox" {...props} />
    </ComboboxContext.Provider>
  );
}
